import { FC } from 'react'
import { Switch, Route, Redirect } from 'react-router-dom'

import { useAppDispatch, useAppSelector } from 'hooks/store'
import LoginPageForgotUserIdOrPassword from 'components/features/login/LoginPageForgotUserIdOrPassword'
import LoginForgotValidate from 'components/features/login/LoginForgotValidate'
import ResetPassword from 'components/features/login/ResetPassword'
import { loadActiveCaseFromSessionStorage } from 'reducers/activecase/activecaseSessionStorage'
import { setActiveCase } from 'reducers/activecase/activecaseSlice'
import { loadDocumentProcessingFromSessionStorage } from 'reducers/document/documentProcessingSessionStorage'
import { setDocumentProcessing } from 'reducers/document/documentProcessingSlice'
import { loadUserProfileFromSessionStorage } from 'reducers/userprofile/userprofileSessionStorage'
import { setUserProfile } from 'reducers/userprofile/userprofileSlice'
import { loadActiveCourseFromSessionStorage } from 'reducers/activecourse/activecourseSessionStorage'
import { setActiveCourse } from 'reducers/activecourse/activecourseSlice'
import { loadActiveSectionFromSessionStorage } from 'reducers/activesection/activesectionSessionStorage'
import { setActiveSection } from 'reducers/activesection/activesectionSlice'

import LoginPage from '../LoginPage'
import LoginForgotNoAccount from '../LoginForgotNoAccount'
import LoginForgotAccountNotSetup from '../LoginForgotAccountNotSetup'
import LoginPageTwoFactorAuth from '../LoginPageTwoFactorAuth'

const LoginPageMain: FC = () => {
  const sessionStor = window.sessionStorage
  const dispatch = useAppDispatch()
  const authentication = useAppSelector((state) => state.authentication)

  if (authentication.isAuthenticated === true && authentication.accessToken) {
    const refreshPath = sessionStor.getItem('refreshPath')
    // if refresh path has a value a browser refresh has happended so reload state from sessionStorage and redirect to the route that the user was on when refreshed
    if (refreshPath && refreshPath !== '/login') {
      sessionStor.removeItem('refreshPath')
      const activeCase = loadActiveCaseFromSessionStorage()
      const documentProcessing = loadDocumentProcessingFromSessionStorage()
      const activeCourse = loadActiveCourseFromSessionStorage()
      const activeSection = loadActiveSectionFromSessionStorage()
      const userProfile = loadUserProfileFromSessionStorage()
      dispatch(setActiveCase(activeCase))
      dispatch(setDocumentProcessing(documentProcessing))
      dispatch(setActiveCourse(activeCourse))
      dispatch(setActiveSection(activeSection))
      dispatch(setUserProfile(userProfile))

      console.log('redirect to refresh path', refreshPath)
      return <Redirect to={refreshPath} />
    }

    if (authentication.account?.caseCount === 1) {
      return (
        <Redirect
          to={{
            pathname: '/dashboard/case'
          }}
        />
      )
    } else {
      return (
        <Redirect
          to={{
            pathname: '/client'
          }}
        />
      )
    }
  }

  return (
    <Switch>
      <Route path='/login' exact>
        <LoginPage />
      </Route>
      <Route path='/login/2fauth' exact>
        <LoginPageTwoFactorAuth />
      </Route>
      <Route path='/login/forgot' exact>
        <LoginPageForgotUserIdOrPassword />
      </Route>
      <Route path='/login/forgot/validate' exact>
        <LoginForgotValidate />
      </Route>
      <Route path='/login/forgot/noaccount' exact>
        <LoginForgotNoAccount />
      </Route>
      <Route path='/login/forgot/account-not-setup' exact>
        <LoginForgotAccountNotSetup />
      </Route>
      <Route path='/login/reset/:accountId?' exact>
        <ResetPassword />
      </Route>
    </Switch>
  )
}

export default LoginPageMain
